module.exports = __webpack_public_path__ + "img/flavor_banana.b780e660.png";